import type { ExtractorData } from 'Core/actions/dialog';
import { showVehicleDialogSelector } from 'Core/selectors/fitmentSearch/fitmentSearch';
import type { ReduxStateType } from 'Core/store';

export const extractorDataSelector = (state: ReduxStateType): ExtractorData => state.dialog.extractorData;

export function createDialogOpenedSelector(name: string) {
  return (state: ReduxStateType): boolean =>
    name === 'VehicleWidgetDialog' ? showVehicleDialogSelector(state) : state.dialog.opened.includes(name);
}
